var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tenantConversationList.length > 0 || _vm.landlordConversationList.length > 0 ? _c("div", {
    staticClass: "im section"
  }, [_c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" 房客咨询 "), _c("el-tag", {
    attrs: {
      type: "danger",
      size: "mini"
    }
  }, [_vm._v(_vm._s(_vm.tenantConversationCount))])], 1), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.tenantConversationList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.goChatRecord(item);
        }
      }
    }, [_c("wlc-image", {
      staticClass: "avatar",
      attrs: {
        width: "38",
        height: "38",
        compression: true,
        enlarged: false,
        src: item.otherAvatar
      }
    }), _c("div", {
      staticClass: "info"
    }, [_c("div", {
      staticClass: "header"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.otherName))])]), _c("div", {
      staticClass: "bottom"
    }, [_c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.lastTime.split(" ")[0]))]), _c("span", {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.recordCount))])])])], 1);
  }), 0)]), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" 联系房东 "), _c("el-tag", {
    attrs: {
      type: "danger",
      size: "mini"
    }
  }, [_vm._v(_vm._s(_vm.landlordConversationCount))])], 1), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.landlordConversationList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.goChatRecord(item);
        }
      }
    }, [_c("wlc-image", {
      staticClass: "avatar",
      attrs: {
        width: "38",
        height: "38",
        compression: true,
        enlarged: false,
        src: item.otherAvatar
      }
    }), _c("div", {
      staticClass: "info"
    }, [_c("div", {
      staticClass: "header"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.otherName))])]), _c("div", {
      staticClass: "bottom"
    }, [_c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.lastTime.split(" ")[0]))]), _c("span", {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.recordCount))])])])], 1);
  }), 0)])]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };